/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function BackHome({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m6.81 3.403.772-.655L8.467 2a1 1 0 0 1 1.31.015l4.887 4.34a1 1 0 0 1 .336.747v6.458a1 1 0 0 1-1 1h-2.066a1 1 0 0 1-1-1V10.92a1 1 0 0 0-1-1H8.322a1 1 0 0 0-1 1v2.641a1 1 0 0 1-1 1H4.781M3.625 10.195 1 7.965 2.816 6.47l.809-.665M1 7.963h5.469" /></svg>;
}
;